import * as hocs from './hocs';

export class TagTypeService {
    tagTypes = {};

    registerTagType = (tagTypes = {}) => {
        Object.assign(this.tagTypes,
            Object.entries(tagTypes)
                .reduce((a, [tagType, tagTypeComponent]) => ({ ...a, [tagType]: hocs.withLogger(tagTypeComponent) }), {})
        );
    };

    getTagTypes = () => {
        return { ...this.tagTypes };
    };
}

export const tagTypeService = new TagTypeService();
